import { render, staticRenderFns } from "./controls.vue?vue&type=template&id=6504d28a&scoped=true"
import script from "./controls.vue?vue&type=script&lang=js"
export * from "./controls.vue?vue&type=script&lang=js"
import style0 from "./controls.vue?vue&type=style&index=0&id=6504d28a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504d28a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6504d28a')) {
      api.createRecord('6504d28a', component.options)
    } else {
      api.reload('6504d28a', component.options)
    }
    module.hot.accept("./controls.vue?vue&type=template&id=6504d28a&scoped=true", function () {
      api.rerender('6504d28a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/member/controls.vue"
export default component.exports